import React, { ComponentProps } from 'react';

import { Animation } from 'shared/presentation/components/atoms';
import { Button } from 'shared/presentation/components/molecules';
import { TIconType } from 'shared/presentation/constants';

import * as S from './styles';

interface IStatusInformationProps {
  animation: ComponentProps<typeof Animation>['animation'];
  loop?: ComponentProps<typeof Animation>['loop'];
  title: string;
  message: string;
  actions: Array<{
    text: string;
    icon: TIconType;
    onClick: () => void;
  }>;
}

const StatusInformation: React.FC<IStatusInformationProps> = ({
  animation,
  loop = true,
  title,
  message,
  actions,
}) => (
  <S.Container>
    <Animation animation={animation} loop={loop} />

    <section className="informations">
      <h1 className="title">{title}</h1>
      <p className="message">{message}</p>
    </section>

    <div>
      {actions.map(({ text, icon, onClick }) => (
        <Button key={text} onClick={onClick} icon={icon} iconPosition="right">
          {text}
        </Button>
      ))}
    </div>
  </S.Container>
);

export default StatusInformation;
